import { useQuery } from '@tanstack/react-query';
import { errorsService } from '@/services/errors-service';
import { Specification, SeverityLevel } from '@/models/specification';

export function useSpecifications() {
  return useQuery<Specification[]>({
    queryKey: ['specifications'],
    queryFn: () => errorsService.getSpecificationsList(),
  });
}

export function useSeverityLevels(specificationId?: number) {
  return useQuery<SeverityLevel[]>({
    queryKey: ['severityLevels', specificationId],
    queryFn: () => {
      if (!specificationId) {
        throw new Error('Specification ID is required');
      }
      return errorsService.getSeverityLevelsList(specificationId);
    },
    enabled: Boolean(specificationId),
  });
}
